import React from 'react';
import { AlteracaoNcmEmLoteContent } from './AlteracaoNcmEmLoteContent';
import { AlteracaoNcmEmLoteProvider } from './contexts/AlteracaoNcmEmLoteContext';

export const AlteracaoNcmEmLote: React.FC = () => {
  return (
    <AlteracaoNcmEmLoteProvider>
      <AlteracaoNcmEmLoteContent />
    </AlteracaoNcmEmLoteProvider>
  );
};
